import { render } from "./AccountSettings.vue?vue&type=template&id=f34614ae&scoped=true"
import script from "./AccountSettings.vue?vue&type=script&lang=js"
export * from "./AccountSettings.vue?vue&type=script&lang=js"

import "./AccountSettings.vue?vue&type=style&index=0&id=f34614ae&scoped=true&lang=css"

import exportComponent from "/Users/arkane/Dev/Projects/Web/ecole-alpha.proj/ecole-alpha.2025-2026.web/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.28_vue@3.3.8_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f34614ae"]])

export default __exports__